import {departmentStateActions} from '../../const/actionType';
const initialState = {
  departments: [],
  selectedDepartment: null,
  isDepartmentReady: false,
};

export default function departmentState(state = initialState, action) {
  switch (action.type) {
    case departmentStateActions.SET_DEPARTMENTS:
      return {...state, departments: action.departments};
    case departmentStateActions.SET_SELECTED_DEPARTMENT:
      return {...state, selectedDepartment: action.selected};
    case departmentStateActions.SET_IS_DEPARTMENT_READY:
      return {...state, isDepartmentReady: action.value};
    default:
      return state;
  }
}
